import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const OrderedListIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            <path d="M7 7.50098H20" stroke="currentColor" />
            <path d="M7 12.501H20" stroke="currentColor" />
            <path d="M7 17.501H20" stroke="currentColor" />
            <path
                d="M4.49438 5.54492C4.49438 5.91992 4.26938 6.26492 3.61438 6.26492V6.86492C3.85938 6.86492 4.14938 6.86492 4.34438 6.66492V8.99992H5.19438V5.54492H4.49438Z"
                fill="currentColor"
            />
            <path
                d="M4.00735 11.8051C4.00735 11.3301 4.22235 11.1501 4.54735 11.1501C4.81735 11.1501 4.96735 11.3101 4.96735 11.5751C4.96735 12.0301 4.38235 12.3001 3.76235 12.8151C3.45735 13.0701 3.15735 13.4251 3.15735 14.0001H5.81735V13.3151H4.35235V13.3051C4.79735 12.8651 5.81735 12.4251 5.81735 11.5151C5.81735 10.8551 5.31735 10.4651 4.57235 10.4651C3.63735 10.4651 3.20735 10.9951 3.20735 11.8051H4.00735Z"
                fill="currentColor"
            />
            <path
                d="M3.97587 16.6051C3.97587 16.2751 4.22087 16.1501 4.48587 16.1501C4.76587 16.1501 4.93587 16.2601 4.93587 16.5551C4.93587 16.8151 4.75087 16.9351 4.38087 16.9351H4.22587V17.5201H4.40087C4.80087 17.5201 5.03587 17.6451 5.03587 17.9801C5.03587 18.2401 4.86587 18.3951 4.50587 18.3951C4.06087 18.3951 3.87587 18.1801 3.87587 17.7801H3.07587C3.07587 18.6101 3.59087 19.0801 4.56587 19.0801C5.33087 19.0801 5.88587 18.7101 5.88587 18.0301C5.88587 17.6051 5.71087 17.3151 5.28587 17.1801V17.1701C5.56587 17.0251 5.78587 16.7901 5.78587 16.4151C5.78587 15.8051 5.19587 15.4651 4.55087 15.4651C3.66587 15.4651 3.17587 15.9451 3.17587 16.6051H3.97587Z"
                fill="currentColor"
            />
        </svg>
    </IconWrapper>
)
